import DeForm from "@shared/DeForm/DeForm";

export default DeForm;
